export const SET_FETCHING_DATA = 'costAnalysis/SET_FETCHING_DATA';
export const SET_ANALYSIS_DATA = 'costAnalysis/SET_ANALYSIS_DATA';
export const SET_FUND_ANALYSIS_DATA = 'costAnalysis/SET_FUND_ANALYSIS_DATA';
export const SET_PAGINATED_FUND_ANALYSIS =
  'costAnalysis/SET_PAGINATED_FUND_ANALYSIS';
export const SET_FUND_ANALYSIS_PAGINATION =
  'costAnalysis/SET_FUND_ANALYSIS_PAGINATION';
export const SET_PAGINATED_FUNDS = 'costAnalysis/SET_PAGINATED_FUNDS';
export const SET_ALL_ASSET_CLASSES = 'costAnalysis/SET_ALL_ASSET_CLASSES';
export const SET_ALL_ORGANISATIONS = 'costAnalysis/SET_ALL_ORGANISATIONS';
export const SET_ALL_TIME_PERIODS = 'costAnalysis/SET_ALL_TIME_PERIODS';
export const SET_ALL_ORGANISATION_TYPES =
  'costAnalysis/SET_ALL_ORGANISATION_TYPES';
export const SET_ALL_ASSET_MANAGERS = 'costAnalysis/SET_ALL_ASSET_MANAGERS';
export const SET_ALL_FUNDS_PER_ORGANISATION =
  'costAnalysis/SET_ALL_FUNDS_PER_ORGANISATION';
export const SET_ALL_EXPOSED_FUNDS_PER_ORGANISATION =
  'costAnalysis/SET_ALL_EXPOSED_FUNDS_PER_ORGANISATION';
export const SET_ALL_EXPOSED_PENSION_SCHEMES =
  'costAnalysis/SET_ALL_EXPOSED_PENSION_SCHEMES';
export const SET_CURRENT_ORGANISATION = 'costAnalysis/SET_CURRENT_ORGANISATION';

export const SET_APPLIED_FILTERS = 'costAnalysis/SET_APPLIED_FILTERS';
export const SET_FILTER_FUNDS = 'costAnalysis/SET_FILTER_FUNDS';
export const SET_FILTER_PENSION_SCHEMES =
  'costAnalysis/SET_FILTER_PENSION_SCHEMES';
export const SET_FILTER_ASSET_CLASSES = 'costAnalysis/SET_FILTER_ASSET_CLASSES';
export const SET_FILTER_TIME_PERIODS = 'costAnalysis/SET_FILTER_TIME_PERIODS';
export const SET_FILTER_SUB_FUNDS = 'costAnalysis/SET_FILTER_SUB_FUNDS';
